import React from "react"
import {Button} from "antd"
import "./Btn.css"
function ButtonComponent({data,handleClick,icon,buttonColor}){
    return <Button onClick={handleClick} id="AntBtnEdit" style={{backgroundColor:buttonColor}}>{icon}{data?data:"Test Redux"}</Button>
        
}

export default ButtonComponent